import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Dialog from "components/common/Dialog";
import JarvisButton from "components/JarvisButton";

const ImportantMsgDialog = (props) => {
  const { open, onConfirm, message } = props;

  return (
    <Dialog
      open={open}
      title=""
      disableCloseIcon
      maxWidth="xs"
      sx={{ borderRadius: "10px" }}
      contentComponent={() => (
        <Box sx={{ maxWidth: "300px", margin: "0 auto", textAlign: "center" }}>
          <Text
            variant="subtitle1"
            sx={{ color: "#1E1E1E", lineHeight: 1.3 }}
          >
            {message}
          </Text>
        </Box>
      )}
      actionComponent={(onClose) => {
        return (
          <Box mb={2} textAlign="center">
            <JarvisButton
              onClick={() => onConfirm(onClose)}
              disableEndIcon={true}
              variant="outlined"
            >
              Continue
            </JarvisButton>
          </Box>
        );
      }}
    />
  );
};

export default ImportantMsgDialog;
